import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import Scrollable from "@components/ui/Scrollable";
import IndexHashtagList from "./HashtagList";
import {gsap} from "gsap";
import ViewportRoot from "@ts/sframe/ViewportRoot";

export default class IndexPromoteArea extends ComponentBase
{
  currentId: string;
  $wrapper: JQuery;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.currentId = this.$root[0].dataset.currentHashtagId;
    
    this.$wrapper = this.$root.find(".group-wrapper");

    let hashtagList = new IndexHashtagList(this.$root.find(`[component="hashtag-list"]`)[0] as ComponentElem, this.currentId);
    hashtagList.emitter.addListener("change", (hashtagId) =>
    {
      this.currentId = hashtagId;
      this.update();
    });

    ViewportRoot.emitter.addListener("majorChanged", ()=>{
      this.update();
    });
  }

  update()
  {
    let groupElem = this.$root.find(`.group[hashtag="${this.currentId}"]`)[0];
    if(groupElem)
    {
      let targetLeft = -groupElem.offsetLeft,
      currentLeft = parseInt(this.$wrapper.css("left")),
      duration = .2 + Math.abs(targetLeft - currentLeft) / 3000;
      
      gsap.to(this.$wrapper, {duration: duration, left: targetLeft})
    }
    
    
  }
}